import { uuidV4 } from '../util/others/uuid-v4.js';

function CreateTendon(joints) {
    return {
        lockEnds: [false, false],
        realLength: 0,
        points: [joints[0].pos.slice(), joints[1].pos.slice()],
        id: uuidV4()
    };
}

export { CreateTendon };
//# sourceMappingURL=create-tendon.js.map
